import getLogger from '@ignitesales/logger-es';
import {buildPageUrl, ignite} from '@ignitesales/neuro-application';
import queryString from 'query-string';
import getAccounts from '../services/Accounts/getAccounts.mjs';
import fetchContacts from '../services/Contacts/fetchContacts.mjs';
import { contactLeadUpdate } from '@ignitesales/neuro-application/src/neuro-guide/state';
import sendToSalesforce from '../services/Salesforce/sendToSalesforce.mjs';
import { notifySuccess, notifyError } from '@ignitesales/neuro-application/src/neuro-guide/components/ToastNotifications';
import mockCompanyResults from './mockCompanyResults.json';
import mockContactResults from './mockContactResults.json';

const logger = getLogger({ module: 'commerce-business-branch-actions' });

const CommerceBusinessBranchActions = {
  DEEP_LINK_CHECK_FINISHED: 'DEEP_LINK_CHECK_FINISHED',
  SALESFORCE_COMPANY_SEARCH_INIT: 'SALESFORCE_COMPANY_SEARCH_INIT',
  SALESFORCE_COMPANY_SEARCH_SUCCESS: 'SALESFORCE_COMPANY_SEARCH_SUCCESS',
  SALESFORCE_COMPANY_SEARCH_FAILURE: 'SALESFORCE_COMPANY_SEARCH_FAILURE',
  SALESFORCE_CONTACT_SEARCH_INIT: 'SALESFORCE_CONTACT_SEARCH_INIT',
  SALESFORCE_CONTACT_SEARCH_SUCCESS: 'SALESFORCE_CONTACT_SEARCH_SUCCESS',
  SALESFORCE_CONTACT_SEARCH_FAILURE: 'SALESFORCE_CONTACT_SEARCH_FAILURE',
  // TODO: might not need these actions...
  SALESFORCE_SUBMIT_SUCCESS: 'SALESFORCE_SUBMIT_SUCCESS',
  SALESFORCE_SUBMIT_FAILURE: 'SALESFORCE_SUBMIT_FAILURE',
  SUBMITTED_PRODUCTS_LOAD_INIT: 'SUBMITTED_PRODUCTS_LOAD_INIT',
  SUBMITTED_PRODUCTS_LOAD_SUCCESS: 'SUBMITTED_PRODUCTS_LOAD_SUCCESS',
  SUBMITTED_PRODUCTS_LOAD_FAILURE: 'SUBMITTED_PRODUCTS_LOAD_FAILURE',
  SUBMITTED_PRODUCTS_UPDATE_INIT: 'SUBMITTED_PRODUCTS_UPDATE_INIT',
  SUBMITTED_PRODUCTS_UPDATE_SUCCESS: 'SUBMITTED_PRODUCTS_UPDATE_SUCCESS',
  SUBMITTED_PRODUCTS_UPDATE_FAILURE: 'SUBMITTED_PRODUCTS_UPDATE_FAILURE',
  PRODUCT_SELECTED: 'PRODUCT_SELECTED',
};

const checkAndGoToDeepLink = () => {
  const validPaths = ['checking', 'savings', 'borrow', 'all'];

  return async (dispatch, getState) => {
    try {
      const urlQuery = window.location.search;
      logger.debug('Checking for deep link', urlQuery);
      const parsed = queryString.parse(urlQuery);
      const pathParam = parsed.path || '';

      if (pathParam && validPaths.includes(pathParam)) {
        const reasonForVisitAnswers = await ignite.answerService.getAnswer('reasonForVisit');
        const newAnswerValue = reasonForVisitAnswers.value && reasonForVisitAnswers.value.length > 0
          ? [...reasonForVisitAnswers.value, pathParam]
          : [pathParam];

        logger.debug('Saving answers via deep link', newAnswerValue);
        await ignite.answerService.saveAnswer({
          appkey: 'reasonForVisit',
          value: newAnswerValue,
          timestamp: new Date()
        });

        const state = getState();
        const { user: { uuid } } = state;
        const isAllPath = pathParam === 'all' ? true : false;
        const redirectUrl = buildPageUrl({
          type: 'survey',
          uuid,
          path: { key: 'entry' },
          page: { key: isAllPath ? 'reasonForVisit' : 'isCustomer' }
        });
        logger.debug('redirecting via deep link', redirectUrl)
        window.location.href = redirectUrl;
      } else {
        dispatch({ type: CommerceBusinessBranchActions.DEEP_LINK_CHECK_FINISHED });
      }
    } catch (ex) {
      dispatch({ type: CommerceBusinessBranchActions.DEEP_LINK_CHECK_FINISHED })
    }
  }
}

const getCompanyInit = () => ({
  type: CommerceBusinessBranchActions.SALESFORCE_COMPANY_SEARCH_INIT,
});

const getCompanySuccess = payload => ({
  type: CommerceBusinessBranchActions.SALESFORCE_COMPANY_SEARCH_SUCCESS,
  payload,
});

const getCompanyFailure = () => ({
  type: CommerceBusinessBranchActions.SALESFORCE_COMPANY_SEARCH_FAILURE
});

const getContactInit = () => ({
  type: CommerceBusinessBranchActions.SALESFORCE_CONTACT_SEARCH_INIT
});

const getContactSuccess = (payload, accountId) => ({
  type: CommerceBusinessBranchActions.SALESFORCE_CONTACT_SEARCH_SUCCESS,
  payload,
  accountId
});

const getContactFailure = () => ({
  type: CommerceBusinessBranchActions.SALESFORCE_CONTACT_SEARCH_FAILURE
});

const sendToInsightSuccess = payload => ({
  type: CommerceBusinessBranchActions.SALESFORCE_SUBMIT_SUCCESS,
  payload,
});

const sendToInsightFailure = () => ({
  type: CommerceBusinessBranchActions.SALESFORCE_SUBMIT_FAILURE
});

const getCompanies = async (query, uuid, isMockMode) => {
  if (isMockMode) {
    return new Promise( resolve => setTimeout(() => resolve(mockCompanyResults), 3000));
  }
  return getAccounts(query, uuid)
};

const getContacts = async (accountId, uuid, employee, isMockMode) => {
  if (isMockMode) {
    return new Promise( resolve => setTimeout(() => resolve(mockContactResults), 3000));
  }
  return fetchContacts(accountId, uuid, employee)
}

const searchForCompany = (query, uuid, isMockMode) => async (dispatch) => {
  dispatch(getCompanyInit());
  try {
    const response = await getCompanies(query, uuid, isMockMode);
    if (response) {
      return dispatch(getCompanySuccess(response));
    }
    else {
      return dispatch(getCompanyFailure());
    }
  }
  catch (e) {
    return dispatch(getCompanyFailure());
  }
};

const searchForContact = (accountId, uuid, employee, isMockMode) => async (dispatch) => {
  dispatch(getContactInit());
  try {
    const response = await getContacts(accountId, uuid, employee, isMockMode);
    if (response) {
      return dispatch(getContactSuccess(response, accountId));
    }
    else {
      return dispatch(getContactFailure());
    }
  }
  catch (e) {
    return dispatch(getContactFailure());
  }
};


const sendToInsight = (lead, uuid, employee, data, setLoading, questionsOrder) => async (dispatch) => {
  dispatch(contactLeadUpdate({ contactLead: lead }));
  setLoading(true);
  try {
    const response = await sendToSalesforce(uuid, employee, data, questionsOrder);
    if (response) {
      notifySuccess('summary.sendToInsight');
      setLoading(false);
      return dispatch(sendToInsightSuccess(response));
    }
    else {
      notifyError('summary.sendToInsight');
      setLoading(false);
      return dispatch(sendToInsightFailure());
    }
  }
  catch (e) {
    notifyError('summary.sendToInsight');
    setLoading(false);
    return dispatch(sendToInsightFailure());
  }
};


/**
 * NOTE: 
 * As of November 2024, Commerce Business has the functionality to keep a record of the productsIds 
 * that were in the cart when a guide is submitted. 
 * This state do not affect the Neuro 'productCart' state or the 'productsSavedToCart' appkey,
 * It's only for UI manipulation.
 */
const loadSubmittedProducts = () => async (dispatch) => {
  dispatch(loadSubmittedProductsInit());
  try {
    const response = await window.ignite.answerService.getAnswer('submittedProducts');
    const fetchedSubmittedProducts = !!response?.value?.length ? response?.value : [];
    dispatch(loadSubmittedProductsSuccess(fetchedSubmittedProducts));
  }
  catch (error) {
    dispatch(loadSubmittedProductsFailure());
  }
};

const updateSubmittedProducts = (ids) => async (dispatch) => {
  dispatch(updateSubmittedProductsInit());
  try {
    window.ignite.answerService.saveAnswer({
      appkey: 'submittedProducts',
      value: ids,
      timestamp: new Date(),
    });
    dispatch(updateSubmittedProductsSuccess(ids));
  }
  catch (error) {
    dispatch(updateSubmittedProductsFailure());
  }
};

const loadSubmittedProductsInit = () => ({
  type: CommerceBusinessBranchActions.SUBMITTED_PRODUCTS_LOAD_INIT,
});

const loadSubmittedProductsSuccess = (payload) => ({
  type: CommerceBusinessBranchActions.SUBMITTED_PRODUCTS_LOAD_SUCCESS,
  payload
});

const loadSubmittedProductsFailure = () => ({
  type: CommerceBusinessBranchActions.SUBMITTED_PRODUCTS_LOAD_FAILURE
});

const updateSubmittedProductsInit = () => ({
  type: CommerceBusinessBranchActions.SUBMITTED_PRODUCTS_UPDATE_INIT,
});

const updateSubmittedProductsSuccess = (payload) => ({
  type: CommerceBusinessBranchActions.SUBMITTED_PRODUCTS_UPDATE_SUCCESS,
  payload
});

const updateSubmittedProductsFailure = () => ({
  type: CommerceBusinessBranchActions.SUBMITTED_PRODUCTS_UPDATE_FAILURE
});

const productSelected = () => ({
  type: CommerceBusinessBranchActions.PRODUCT_SELECTED
});

export {
  CommerceBusinessBranchActions,
  checkAndGoToDeepLink,
  searchForCompany,
  searchForContact,
  sendToInsight,
  loadSubmittedProducts,
  updateSubmittedProducts,
  productSelected,
}
